import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { InvestgationReqMode, ScanReqModel } from '../models/InvestgationReqMode';

@Injectable()
export class InvestgationReqService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }
  public GetInvestgationReq(PatientCode: string , InvDate: string) {
    let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      params = params.append("InvDate", InvDate);
      const options = {
          params: params
      };
      return this.http.get<InvestgationReqMode>(this.urlsconfig.WebAPIURL_Test + 'api/InvestgationReq/GetInvestgationReq',options);
  }
  public AddInvestgationReq(nurseassessment: InvestgationReqMode) {

      return this.http.post<InvestgationReqMode>(this.urlsconfig.WebAPIURL_Test + 'api/InvestgationReq/AddInvestgationReq', nurseassessment);
  }
///////////------------------------------------------------------------
public GetScanReq(PatientCode: string , ScanDate: string) {
  let params = new HttpParams();
    params = params.append("PatientCode", PatientCode);
    params = params.append("ScanDate", ScanDate);
    const options = {
        params: params
    };
    return this.http.get<ScanReqModel>(this.urlsconfig.WebAPIURL_Test + 'api/InvestgationReq/GetScanReq',options);
}
public AddScanReq(ScanReq: ScanReqModel) {
  debugger;
  console.log("LL:",this.urlsconfig.WebAPIURL_Test,"-",ScanReq)
  return this.http.post<ScanReqModel>(this.urlsconfig.WebAPIURL_Test + 'api/InvestgationReq/AddScanReqReq',ScanReq);
  }


}
